import { axiosClient, axiosPHP, axiosClientSN } from "../api/axios";
export const postTransportBrom = async data => {
  try {
    const res = await axiosClient.post("/transport", data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    });
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getTipoDoc = async () => {
  try {
    const res = await axiosPHP("/dtTipoDoc.php");
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getTipoPersona = async () => {
  try {
    const res = await axiosPHP("/dtTipoPersona.php");
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getCondIVA = async () => {
  try {
    const res = await axiosPHP("/dtCondIva.php");
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getProvincias = async () => {
  try {
    const res = await axiosPHP("/dtProvincias.php");
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getBarrios = async () => {
  try {
    const res = await axiosPHP("/dtBarrios.php");
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }
};
export const getCalles = async () => {
  try {
    const res = await axiosPHP("/dtCalles.php");
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getCP = async cp => {
  try {
    const res = await axiosPHP("/dtCodPosProvxCP.php/?cp=" + cp);
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const postContribCrear = async data => {
  try {
    const res = await axiosPHP.post("/contribCrear.php", { data: data });
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const postGenerarComprobante = async ({ conceptos, cc }) => {
  try {
    const { data } = await axiosClientSN.post(
      `/comprobanteVS/genera.php?tpcomp=9&recurso=01&conceptos=${conceptos}&cc=${cc}`
    );
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const mp = async nro_comp => {
  try {
    const res = await axiosClientSN(
      `/comprobanteVS/mercPago.php?tp_comprob=9&nr_comprob=${nro_comp}`
    );
    window.open(res.data.url);
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const postGenerarConceptos = async concept => {
  try {
    const { data } = await axiosClientSN.post(
      `/consultas/conceptos.php?recurso=01&conceptos=${concept}`
    );
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};
